import React, { useEffect, useState } from 'react';
import useAxios from 'axios-hooks';
import { PrimaryButton } from '@fluentui/react';
import { Field, Form, Formik } from 'formik';
import { useParams,useHistory } from 'react-router-dom';
import Select from "react-select";
import { FixedSizeList as List } from "react-window";
import TextField from '../../../../Forms/TextField';
import Toast from '../../../../Forms/Toast';
import TextCKEditor from '../../../../Forms/TextCKEditor';
import FeatureSummary from '../../../../Util/FeatureSummary';
const newCoBrandSettingsObject = {
    coBrandId: null,
    disclaimerMessage: null
};

const CustomMenuList = ({ children, ...props }) => {
    const height = 35;
    const itemCount = children.length;
    const totalHeight = Math.min(300, itemCount * height);

    return (
        <List height={totalHeight} itemCount={itemCount} itemSize={height} width="100%">
            {({ index, style }) => (
                <div
                    style={{
                        ...style,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        padding: "0 8px",
                        boxSizing: "border-box",
                    }}
                    title={children[index]?.props?.children}
                >
                    {children[index]}
                </div>
            )}
        </List>
    );
};

const WizardPage = () => {
    const [showToast, setShowToast] = React.useState(false);
    const [showError, setShowError] = React.useState(false);

    const { coBrandId: idFromParams } = useParams();

    const [{ data: domain, loading: loading }, getDisclaimer] = useAxios(
        { url: `/internal/cobrand/disclaimer-message/${idFromParams}`, method: 'GET' },
        { manual: true },
    );

    useEffect(() => {
        if (idFromParams) {
            getDisclaimer();
        }
    }, [idFromParams]);

    const [{ data: cobrands, loading: loadingCobrands }] = useAxios('/internal/cobrands');
    const cobrandsOptions = cobrands && cobrands.map(u => ({ value: u.cobrandId, label: u.name }));

    const [{ data, loading: submitting }, submitForm] = useAxios(
        { url: `/internal/cobrand/disclaimer-message/update` },
        { manual: true },
    );

    return (
        <Formik
            initialValues={domain ? domain : newCoBrandSettingsObject}
            onSubmit={async (values, { resetForm }) => {
                setShowError(false);
                let result = await submitForm({
                    url: "/internal/cobrand/disclaimer-message/update",
                    method: "POST",
                    data: {
                        CoBrandId: values.coBrandId,
                        DisclaimerMessage: values.disclaimerMessage
                    },
                });
                if (!result.isAxiosError) {
                    setShowToast(true);
                    setIsFormDirty(false); 
                }else{
                    setShowError(true);
                }
            }}
            validate={(values) => {
                const errors = {};
                if (!values.disclaimerMessage) {
                    errors.disclaimerMessage = "Disclaimer Message is required";
                } 
                return errors;
            }}
            validateOnBlur
            enableReinitialize={true}
            isInitialValid={false}
        >
            {({ errors, values, setFieldValue, handleSubmit }) => {
                return <Form style={{ maxWidth: "500px", marginBottom: 500 }}>
                    <h4>Disclaimer Message</h4>
                    {showError && <div style={{color: 'rgb(164, 38, 44)'}}>An error has occurred.</div>}
                    <div className="mt-1 mb20">
                        <label className='default-label mt20'>Select Cobrand</label>
                        <Select
                            components={{ MenuList: CustomMenuList }}
                            options={cobrandsOptions}
                            placeholder="Select Cobrand"
                            name="coBrandId"
                            value={cobrandsOptions?.find(
                                (option) => option.value === values.coBrandId
                            )}
                            onChange={(option) => {
                                setFieldValue("coBrandId", option.value);
                            }}
                            isSearchable
                            styles={{
                                menuList: (base) => ({
                                    ...base,
                                    maxHeight: "300px",
                                    overflowY: "auto",
                                }),
                                container: (base) => ({
                                    ...base,
                                    width: 400,
                                }),
                                control: (base) => ({
                                    ...base,
                                    border: "1px solid #aaaaaa",
                                }),
                            }}
                        />
                        {!loading && <div className="mt20">
                        <label className='default-label'>Disclaimer Message <span style={{ color: "#605e5c", fontWeight: 400, fontSize: 12 }}>(supports HTML formatting)</span></label>
                        <TextCKEditor
                            value={values.disclaimerMessage ? values.disclaimerMessage : ""}
                            onChange={(val) => setFieldValue('disclaimerMessage', val)}
                            className="mt10" />
                        </div>
                        }
                       
                        <PrimaryButton
                            className="mt20"
                            onClick={() => handleSubmit()}
                            text={"Update"}
                            disabled={!values.coBrandId || !values.disclaimerMessage}
                        />
                    </div>
                    <Toast show={showToast} message="Saved!" onClose={() => setShowToast(false)} />
                    <FeatureSummary
                        label="About Disclaimer Messages"
                        summary="Create or edit cobrand-specific disclaimer messages that appear on the platform. Use the rich text editor to format the disclaimer content with links, formatting, and other HTML elements as needed for compliance or branding purposes."
                    />
                </Form>
            }}
        </Formik>
    );
};

export default WizardPage;
